import { format, formatDistanceToNowStrict, parseISO } from "date-fns";

export const toDate = (v) => (v ? (v instanceof Date ? v : parseISO(v)) : null);
export const fmtDateTime = (v) => (v ? format(toDate(v), "MMM d, yyyy · h:mm a") : "—");
export const fmtDate = (v) => (v ? format(toDate(v), "MMM d, yyyy") : "—");
export const fmtShort = (v) => (v ? format(toDate(v), "MMM d · h:mm a") : "—");
export const fmtTime = (v) => (v ? format(toDate(v), "h:mm a") : "—");
export const relTime = (v) => (v ? formatDistanceToNowStrict(toDate(v), { addSuffix: true }) : "—");

export function fmtDuration(seconds) {
  const s = Math.max(0, Math.round(seconds || 0));
  const m = Math.floor(s / 60);
  const r = s % 60;
  if (m >= 60) return `${Math.floor(m / 60)}h ${m % 60}m`;
  return m ? `${m}m ${r.toString().padStart(2, "0")}s` : `${r}s`;
}

export function fmtMinutes(mins) {
  if (mins == null) return "—";
  const m = Math.round(mins);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ${m % 60}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}

export function fmtPhone(p) {
  if (!p) return "—";
  const d = String(p).replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  return p;
}

export function scoreTone(score) {
  if (score == null) return { text: "text-slate-400", bg: "bg-slate-500/15", border: "border-slate-500/30", hex: "#64748b" };
  if (score >= 90) return { text: "text-emerald-400", bg: "bg-emerald-500/15", border: "border-emerald-500/30", hex: "#10b981" };
  if (score >= 75) return { text: "text-blue-400", bg: "bg-blue-500/15", border: "border-blue-500/30", hex: "#3b82f6" };
  if (score >= 60) return { text: "text-amber-400", bg: "bg-amber-500/15", border: "border-amber-500/30", hex: "#f59e0b" };
  return { text: "text-red-400", bg: "bg-red-500/15", border: "border-red-500/30", hex: "#ef4444" };
}

export const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);
export const num = (v, d = 0) => (v == null ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: d }));
export const isoDay = (d) => format(d, "yyyy-MM-dd");
